import { render, staticRenderFns } from "./VehiculeForm.vue?vue&type=template&id=87327cce&"
import script from "./VehiculeForm.vue?vue&type=script&lang=js&"
export * from "./VehiculeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports